import React from 'react';
import Banner from './Banner';

const Education = () => {
  return (
    <>
      <Banner title="Education" />
      <div className="flex justify-center">
        <div className="timeline-container mr-2">
          <div className="timeline-card p-3 md:p-5 lg:p-6 my-2 md:my-4 text-secondary">
            <p className="text-sm md:text-lg lg:text-2xl font-bold text-primary">
              Bachelor's degree, computer software engineering (2015 - 2019)
            </p>
            <p className="text-sm md:text-lg lg:text-xl py-2 text-secondary">
              University of Vocational Technology
            </p>
            <p className="xs:text-xs">
              The B.Tech program in Information & Communication Technology (ICT)
              is a three-year course of study that combines studies in computer
              science, software development, information systems, multimedia,
              web development, and computer networks.
              <br />
              <br />
              The program has a flexible structure allowing students to choose
              from a number of specializations: software development,
              information systems, computer networks, web development, and
              multimedia production. The program includes the study of contract
              administration, business management, and the presentation of
              information. Over and above this the student will be able to
              specialize in a field relevant to the industry, which will enhance
              the capability and value of the B.Tech graduate to the Information
              and Communication Technology Industry.
            </p>
            <br />
          </div>
        </div>
      </div>
      <div className="flex justify-center">
        <div className="timeline-container mr-2">
          <div className="timeline-card p-3 md:p-5 lg:p-6 my-2 md:my-4 text-secondary">
            <p className="text-sm md:text-lg lg:text-2xl font-bold text-primary">
              National diploma in information and communication technology (2013
              - 2014)
            </p>
            <p className="text-sm md:text-lg lg:text-xl py-2 text-secondary">
              Vocational Training Authority
            </p>
            <p className="xs:text-xs">
              Diploma in Information and Communication Technology is an NVQ
              Level 5 course consisting of eleven syllabus modules that cover
              software developments as well as managerial execution topics based
              on information, communication and project management. <br /> The
              commitment of the institute is to produce skilled and professional
              workforce to fill the void that has been created nationally and
              internationally.
            </p>
            <br />
          </div>
        </div>
      </div>
    </>
  );
};

export default Education;
